export default __webpack_public_path__ + "static/media/artbanner.ad98ce48.jpg";